import { observable } from "mobx";

class AppState
{
    @observable appname = "EasyStarter";  
    @observable whynowrite = "nothing";   
    @observable zerooo = "nothing"; 
    @observable zerocharacter = "nothing";   
    @observable zeroevent = "nothing";   
    @observable zeroenvironment = "nothing";   
    @observable storymodel = "nothing"; 
    @observable charactermodel= "nothing";
    @observable eventmodel= "nothing";   
    @observable environmentmodel= "nothing";  
    @observable bigstory= "nothing";  
    @observable upsetwith= "nothing";
    @observable writingyes= "nothing";
    @observable plotyes= "nothing";   
    @observable formationyes= "nothing";                                         

    
}

export default new AppState();